<template>
    <div v-if="arquivos" class="bg-white" :class="fullscreen ? 'panel-fullscreen' : ''">
        <div class="row">
            <div class="col col-12 text-right">
                <a href="#" @click.prevent="atualizar_mode()" class="mr-3">
                    <i class="fa-solid fa-arrows-left-right fa-fw" v-if="!mode_arrow"></i>
                    <i class="fa-solid fa-arrows-up-down fa-fw" v-else></i>
                </a>

                <a href="#" @click.prevent="fullscreen = !fullscreen" class="mr-4">
                    <i class="fa-solid fa-expand fa-fw" v-if="!fullscreen"></i>  
                    <i class="fa-solid fa-compress fa-fw" v-else></i>
                </a>
            </div>
        </div>

        <div v-for="(arq_view, ivx) in arquivos" :key="ivx">
            <div class="card bg-light" v-if="!mode_arrow || indice_selecionado === ivx" :class="mode_arrow ? 'altura-maxima' : ''">
                <div class="card-header d-flex justify-content-between">
                    <a href="#" @click.prevent="arq_view.arquivo.visibility = !arq_view.arquivo.visibility" class="card-link">
                        {{ arq_view.arquivo.st_titulo }}
                    </a>
                    <div v-if="mode_arrow">
                        <span class="badge badge-secondary ml-3">
                            {{ ivx + 1 }} / {{ arquivos.length }}
                        </span>

                        <a href="#" @click.prevent="indice_selecionado > 0 ? indice_selecionado = indice_selecionado - 1 : ''" class="ml-3">
                            <i class="fa-solid fa-circle-chevron-left fa-fw"></i>
                        </a>
                        <a href="#" @click.prevent="indice_selecionado < ( arquivos.length - 1 ) ? indice_selecionado = indice_selecionado + 1 : ''" class="ml-3">
                            <i class="fa-solid fa-circle-chevron-right fa-fw"></i>
                        </a>
                    </div>
                </div>

                <div class="card-body" v-if=" ( arq_view && arq_view.arquivo.visibility )">
                    <div :src="arq_view ? arq_view.arquivo.temporary_url : ''" style="width: 100%; height: 100%; border: none;" v-if="arq_view && is_image(arq_view.arquivo)">
                        <viewer :images="[arq_view.arquivo.temporary_url]">
                            <figure class="figure">
                                <img :src="arq_view.arquivo.temporary_url" class="figure-img img-fluid rounded" style="max-height: 80vh; max-width: 100%;">
                            </figure>
                        </viewer>
                    </div>

                    <iframe :src="link_office(arq_view.arquivo)" style="width: 100%; height: 100%; border: none;" v-else-if="arq_view && is_office(arq_view.arquivo)">
                        Oops! ocorreu um erro ao abrir o arquivo.
                    </iframe>

                    <iframe :src="arq_view.arquivo ? arq_view.arquivo.temporary_url : ''" :class="mode_arrow ? 'altura-pdf-arrow' : 'altura-pdf'" v-else> <!-- style="width: 100%; height: 580px; border: none; -->
                        Oops! ocorreu um erro ao abrir o arquivo.
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() { 
        return { 
            fullscreen: false, 
            mode_arrow: false, 
            indice_selecionado: 0, 
        }
    },

    props: ['arquivos'], 

    methods: { 
        atualizar_mode() { 
            this.mode_arrow = !this.mode_arrow; 
            this.indice_selecionado = 0;
            
            this.$util.setCookie('var-ma', this.mode_arrow ? 'S' : 'N');
        },

        // Imagens
        is_image (arquivo) { 
            return arquivo.st_tipo_arquivo == 'png' || arquivo.st_tipo_arquivo == 'jpg' || arquivo.st_tipo_arquivo == 'jpeg';
        },

        is_office (arquivo) { 
            return arquivo.st_tipo_arquivo == 'docx' || arquivo.st_tipo_arquivo == 'xlsx' || arquivo.st_tipo_arquivo == 'pptx';
        },

        link_office(arquivo) { 
            return "https://view.officeapps.live.com/op/view.aspx?src=" 
                + encodeURIComponent(arquivo.temporary_url)
                + '&wdEmbedCode=0&wdPrint=0';
        },

    },

    mounted() { 
        this.mode_arrow = this.$util.getCookie('var-ma') == 'S' ? true : false;
    }
}
</script>

<style scoped>
.altura-pdf-arrow { 
    width: 100%; 
    height: 85vh; 
    border: none;
}

.altura-pdf { 
    width: 100%; 
    height: 580px; 
    border: none;
}

.altura-maxima { 
    max-height: 98vh;
}

.panel-fullscreen {
  display: block;
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}
</style>